import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled, { useTheme } from "styled-components";
import { resolveMemberStatus } from "~/lib/helpers";
import Badge from "~/components-shared/Badge";
import { genericColor } from "~/lib/resolvers";
const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${_ref => {
  let {
    $color,
    theme
  } = _ref;
  return genericColor(theme, $color);
}};
  border-radius: 50%;
  color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.primary.text;
}};
  font-size: ${_ref3 => {
  let {
    $size,
    theme
  } = _ref3;
  return $size * theme.typography.fontStep / 3;
}}rem;
  line-height: ${_ref4 => {
  let {
    $size,
    theme
  } = _ref4;
  return $size * theme.typography.fontStep / 3;
}}rem;
  font-weight: 900;
  width: ${_ref5 => {
  let {
    $size,
    theme
  } = _ref5;
  return $size * theme.typography.fontStep;
}}rem;
  min-width: ${_ref6 => {
  let {
    $size,
    theme
  } = _ref6;
  return $size * theme.typography.fontStep;
}}rem;
  height: ${_ref7 => {
  let {
    $size,
    theme
  } = _ref7;
  return $size * theme.typography.fontStep;
}}rem;
  min-height: ${_ref8 => {
  let {
    $size,
    theme
  } = _ref8;
  return $size * theme.typography.fontStep;
}}rem;
  ${_ref9 => {
  let {
    $s,
    theme
  } = _ref9;
  return theme.spacing.resolve(theme, $s);
}};
  overflow: hidden;
  z-index: 0;

  &:after {
    content: "${_ref10 => {
  let {
    $initials
  } = _ref10;
  return $initials;
}}";
    position: absolute;
    top: 40%;
    left: 50%;
    opacity: 0.3;
    font-size: ${_ref11 => {
  let {
    $size,
    theme
  } = _ref11;
  return $size * theme.typography.fontStep * 1.5;
}}rem;
    font-weight: 900;
    color: ${_ref12 => {
  let {
    $color,
    theme
  } = _ref12;
  return genericColor(theme, $color);
}};
    text-shadow: 0 0 35px black;
    transform: rotate(-5deg) translate(-50%, -50%);
    z-index: -1;
  }
`;
const Emoji = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: calc(30% - 0.5em);
  left: calc(15% - 0.5em);
  line-height: 0;
  font-size: calc(0.85rem + 0.4em);
  transition: transform 200ms ease-in-out;
  z-index: 1;
  cursor: pointer;

  &:hover {
    transform: scale(1.1);
  }
`;
const Img = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;
const Status = styled(Badge)`
  position: absolute;
  z-index: 1;
  bottom: -1em;
  left: 50%;
  transform: translateX(-50%);
  border: 2px solid ${_ref13 => {
  let {
    theme
  } = _ref13;
  return theme.colors.background.primary;
}};
`;
const Avatar = _ref14 => {
  let {
    user,
    color = "primary",
    showEmoji = false,
    showStatus = false,
    size = 32,
    s,
    ...rest
  } = _ref14;
  const theme = useTheme();
  const {
    firstName,
    lastName,
    profileImage,
    metadata
  } = user;
  const memberStatus = resolveMemberStatus(theme, user);
  const initials = `${firstName ? firstName.charAt(0).toUpperCase() : ""}${lastName ? lastName.charAt(0).toUpperCase() : ""}`;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $s: s,
    $size: size,
    $color: profileImage ? "transparent" : color,
    $initials: initials
  }, rest), showEmoji && metadata.statusEmoji && metadata.statusText && /*#__PURE__*/React.createElement(Emoji, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-place": "right",
    "data-tooltip-content": metadata.statusText
  }, metadata.statusEmoji), profileImage ? /*#__PURE__*/React.createElement(Img, {
    src: profileImage,
    alt: `${firstName} ${lastName}`
  }) : initials, showStatus && memberStatus && /*#__PURE__*/React.createElement(Status, {
    rounded: true,
    s: {
      px: size / 12,
      py: 0
    },
    fontSize: size / 9,
    lineHeight: size / 5,
    color: memberStatus.color
  }, memberStatus.text));
};
export default Avatar;